export const GET_DOWNLOADS = "GET_DOWNLOADS"
export const GET_DOWNLOADS_SUCCESS = "GET_DOWNLOADS_SUCCESS"
export const GET_DOWNLOADS_FAILED = "GET_DOWNLOADS_FAILED"

export const OPEN_DOWNLOAD_COMPLETED_MODAL = "OPEN_DOWNLOAD_COMPLETED_MODAL"
export const HIDE_DOWNLOAD_COMPLETED_MODAL = "HIDE_DOWNLOAD_COMPLETED_MODAL"

export const DOWNLOAD_COMPLETED = "DOWNLOAD_COMPLETED"

export const DOWNLOAD_RESPONSES_REPORT = "DOWNLOAD_RESPONSES_REPORT"
export const DOWNLOAD_RESPONSES_REPORT_SUCCESS =
  "DOWNLOAD_RESPONSES_REPORT_SUCCESS"
export const DOWNLOAD_RESPONSES_REPORT_FAILED =
  "DOWNLOAD_RESPONSES_REPORT_FAILED"

export const DOWNLOAD_QUESTIONNAIRE_SCORES = "DOWNLOAD_QUESTIONNAIRE_SCORES"
export const DOWNLOAD_QUESTIONNAIRE_SCORES_SUCCESS =
  "DOWNLOAD_QUESTIONNAIRE_SCORES_SUCCESS"
export const DOWNLOAD_QUESTIONNAIRE_SCORES_FAILED =
  "DOWNLOAD_QUESTIONNAIRE_SCORES_FAILED"

export const DOWNLOAD_BOOKING_PAYMENTS = "DOWNLOAD_BOOKING_PAYMENTS"
export const DOWNLOAD_BOOKING_PAYMENTS_SUCCESS =
  "DOWNLOAD_BOOKING_PAYMENTS_SUCCESS"
export const DOWNLOAD_BOOKING_PAYMENTS_FAILED =
  "DOWNLOAD_BOOKING_PAYMENTS_FAILED"

export const DOWNLOAD_FORM_PAYMENTS = "DOWNLOAD_FORM_PAYMENTS"
export const DOWNLOAD_FORM_PAYMENTS_SUCCESS = "DOWNLOAD_FORM_PAYMENTS_SUCCESS"
export const DOWNLOAD_FORM_PAYMENTS_FAILED = "DOWNLOAD_FORM_PAYMENTS_FAILED"

export const DOWNLOAD_VIEWS_BY_USER = "DOWNLOAD_VIEWS_BY_USER"
export const DOWNLOAD_VIEWS_BY_USER_SUCCESS = "DOWNLOAD_VIEWS_BY_USER_SUCCESS"
export const DOWNLOAD_VIEWS_BY_USER_FAILED = "DOWNLOAD_VIEWS_BY_USER_FAILED"

export const DOWNLOAD_REFER_FRIEND_REPORT = "DOWNLOAD_REFER_FRIEND_REPORT"
export const DOWNLOAD_REFER_FRIEND_REPORT_SUCCESS =
  "DOWNLOAD_REFER_FRIEND_REPORT_SUCCESS"
export const DOWNLOAD_REFER_FRIEND_REPORT_FAILED =
  "DOWNLOAD_REFER_FRIEND_REPORT_FAILED"

export const DOWNLOAD_ATTENDEE_LIST = "DOWNLOAD_ATTENDEE_LIST"
export const DOWNLOAD_ATTENDEE_LIST_SUCCESS = "DOWNLOAD_ATTENDEE_LIST_SUCCESS"
export const DOWNLOAD_ATTENDEE_LIST_FAILED = "DOWNLOAD_ATTENDEE_LIST_FAILED"

export const DOWNLOAD_CALENDAR_GROUP_REPORTS = "DOWNLOAD_CALENDAR_GROUP_REPORTS"
export const DOWNLOAD_CALENDAR_GROUP_REPORTS_SUCCESS =
  "DOWNLOAD_CALENDAR_GROUP_REPORTS_SUCCESS"
export const DOWNLOAD_CALENDAR_GROUP_REPORTS_FAILED =
  "DOWNLOAD_CALENDAR_GROUP_REPORTS_FAILED"

export const DOWNLOAD_SUB_CALENDAR_REPORTS = "DOWNLOAD_SUB_CALENDAR_REPORTS"
export const DOWNLOAD_SUB_CALENDAR_REPORTS_SUCCESS =
  "DOWNLOAD_SUB_CALENDAR_REPORTS_SUCCESS"
export const DOWNLOAD_SUB_CALENDAR_REPORTS_FAILED =
  "DOWNLOAD_SUB_CALENDAR_REPORTS_FAILED"

export const DOWNLOAD_BOOKING_USER_REPORTS = "DOWNLOAD_USER_BOOKING_REPORTS"
export const DOWNLOAD_BOOKING_USER_REPORTS_SUCCESS =
  "DOWNLOAD_BOOKING_USER_REPORTS_SUCCESS"
export const DOWNLOAD_BOOKING_USER_REPORTS_FAILED =
  "DOWNLOAD_BOOKING_USER_REPORTS_FAILED"

export const DOWNLOAD_BOOKING_REPORTS = "DOWNLOAD_BOOKING_REPORTS"
export const DOWNLOAD_BOOKING_REPORTS_SUCCESS =
  "DOWNLOAD_BOOKING_REPORTS_SUCCESS"
export const DOWNLOAD_BOOKING_REPORTS_FAILED = "DOWNLOAD_BOOKING_REPORTS_FAILED"

export const DOWNLOAD_USERS_LIST = "DOWNLOAD_USERS_LIST"
export const DOWNLOAD_USERS_LIST_SUCCESS = "DOWNLOAD_USERS_LIST_SUCCESS"
export const DOWNLOAD_USERS_LIST_FAILED = "DOWNLOAD_USERS_LIST_FAILED"

export const DOWNLOAD_DEEPLINK_CODES = "DOWNLOAD_DEEPLINK_CODES"
export const DOWNLOAD_DEEPLINK_CODES_SUCCESS = "DOWNLOAD_DEEPLINK_CODES_SUCCESS"
export const DOWNLOAD_DEEPLINK_CODES_FAILED = "DOWNLOAD_DEEPLINK_CODES_FAILED"

export const DOWNLOAD_AXISCARE_REPORTS = "DOWNLOAD_AXISCARE_REPORTS"
export const DOWNLOAD_AXISCARE_REPORTS_SUCCESS =
  "DOWNLOAD_AXISCARE_REPORTS_SUCCESS"
export const DOWNLOAD_AXISCARE_REPORTS_FAILED =
  "DOWNLOAD_AXISCARE_REPORTS_FAILED"
